import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useExcludeChatbotFromPath(excludedPathNames?: string[]) {
    const location = useLocation();
    useEffect(() => {
        const widgetElement = document.getElementById('mercury-widget');
        if (!widgetElement) {
            return;
        }

        if (excludedPathNames?.includes(location.pathname)) {
            widgetElement.style.display = 'none';
        } else {
            widgetElement.style.display = 'block';
        }
    }, [location.pathname]);
}
